import Phaser from 'phaser';
import { audio } from '../game/AudioManager.js';
import { dialogueManager } from '../game/DialogueManager.js';
import { gameState } from '../game/GameState.js';
import { DIALOGUES } from '../data/dialogue.js';
import { cinematicManager } from '../game/UIManager.js';

export class PrologueScene extends Phaser.Scene {
  constructor() {
    super('PrologueScene');
  }

  create() {
    gameState.currentChapter = 1;
    const { width, height } = this.scale;
    audio.playTheme('school');

    // Black backdrop with subtle stars/particles
    this.add.rectangle(width / 2, height / 2, width, height, 0x0a0510);

    cinematicManager.show(
      "PROLOGUE • 2011",
      "The Boy Who Never Turned",
      "A fleeting glance across the schoolyard...",
      3200,
      () => {
        dialogueManager.start(DIALOGUES.prologue_intro, () => {
          this.cameras.main.fade(800, 0, 0, 0);
          this.cameras.main.once('camerafadeoutcomplete', () => {
            this.scene.start('Level1Scene');
          });
        });
      }
    );

    // Skip button
    const skipBtn = this.add.text(width - 40, height - 40, 'SKIP >', {
      fontSize: '16px',
      color: '#888'
    }).setOrigin(1).setInteractive({ useHandCursor: true });

    skipBtn.on('pointerdown', () => {
      cinematicManager.hide();
      dialogueManager.close();
      this.scene.start('Level1Scene');
    });
  }
}
